module.exports = __webpack_public_path__ + "static/img/image1.151cad81.png";